const height = 2350;
const width = 1250;

const cw = width / 10;
const ch = height / 20;

// Please always use width:height ratio 9:14
const ratioIndex = 40
const backCardRatioIndex = 10
const centerCardRatioIndex = 30
const centerMultiCardRatioIndex = 20
const PORTRAIT_CARD_WIDTH = 9 * ratioIndex
const PORTRAIT_CARD_HEIGHT = 14 * ratioIndex
const PORTRAIT_CENTER_CARD_WIDTH = 9 * centerCardRatioIndex
const PORTRAIT_CENTER_CARD_HEIGHT = 14 * centerCardRatioIndex
const PORTRAIT_CENTER_MULTI_CARD_WIDTH = 9 * centerMultiCardRatioIndex
const PORTRAIT_CENTER_MULTI_CARD_HEIGHT = 14 * centerMultiCardRatioIndex
const PORTRAIT_BACK_CARD_WIDTH = 9 * backCardRatioIndex
const PORTRAIT_BACK_CARD_HEIGHT = 14 * backCardRatioIndex

const portraitSeatLayout = {
    2: [
        // { x: cw * 4.25, y: ch * 1.5 },
        { x: cw * 5, y: ch * 2.75 },
        { x: cw * 5, y: ch * 17 }
    ],
    4: [
        { x: cw * 5, y: ch * 2.75 },
        { x: cw * 0.95, y: ch * 5.5 },
        { x: cw * 5, y: ch * 17 },
        { x: cw * 7.5, y: ch * 5.5 },
    ],
    6: [
        { x: cw * 5, y: ch * 2.75 },
        { x: cw * 1.85, y: ch * 2.5 },
        { x: cw * 0.85, y: ch * 5.5 },
        // { x: cw * 1, y: ch * 12.5 },
        { x: cw * 5, y: ch * 17 },
        // { x: cw * 7.5, y: ch * 12.5 },
        { x: cw * 7.5, y: ch * 5.5 },
        { x: cw * 6.85, y: ch * 2.5 },
    ]
}

const portraitSeatPointsLayout = {
    2: [
        // { x: cw * 4.25, y: ch * 1.5 },
        { x: cw * 6.5, y: ch * 4 },
        { x: cw * 1.5, y: ch * 16.5 }
    ],
    4: [
        { x: cw * 6.5, y: ch * 4 },
        { x: cw * 0.95, y: ch * 5.5 },
        { x: cw * 1.5, y: ch * 16.5 },
        { x: cw * 7.5, y: ch * 5.5 },
    ],
    6: [
        { x: cw * 6.5, y: ch * 4 },
        { x: cw * 1.85, y: ch * 2.5 },
        { x: cw * 0.85, y: ch * 5.5 },
        // { x: cw * 1, y: ch * 12.5 },
        { x: cw * 1.5, y: ch * 16.5 },
        // { x: cw * 7.5, y: ch * 12.5 },
        { x: cw * 7.5, y: ch * 5.5 },
        { x: cw * 6.85, y: ch * 2.5 },
    ]
}

// Positions for top 0 set Up

const portraitCardsLayout = {
    2: [
        // { x: cw * 4.65, y: ch * 2 },
        { x: cw * 4.65, y: ch * 4.75 },
        { x: cw * 3.75, y: ch * 16.5 },
    ],
    4: [
        { x: cw * 4.65, y: ch * 4.75 },
        // { x: cw * 1.60, y: ch * 4.75 },
        { x: cw * 1.25, y: ch * 6 },
        { x: cw * 3.75, y: ch * 16.5 },
        { x: cw * 7.9, y: ch * 6 },
        // { x: cw * 8.28, y: ch * 4.75 }
    ],
    6: [
        { x: cw * 4.65, y: ch * 4.75 },
        { x: cw * 2.25, y: ch * 2.95 },
        { x: cw * 1.25, y: ch * 6 },
        // { x: cw * 1, y: ch * 13 },
        { x: cw * 3.75, y: ch * 16.5 },
        // { x: cw * 7.5, y: ch * 13 },
        { x: cw * 7.9, y: ch * 6 },
        { x: cw * 7.25, y: ch * 2.95 }
    ]
}

const portraitStackCenterCardsLayOut = {
    2: [
        { x: cw * 4, y: ch * 9 },
        { x: cw * 4, y: (ch * 9) + (PORTRAIT_CENTER_CARD_HEIGHT * 0.3) }
    ],
    4: [
        { x: cw * 4.35, y: ch * 11 },
        { x: (cw * 4.35) - (PORTRAIT_CENTER_CARD_WIDTH * 0.5), y: (ch * 11) + (PORTRAIT_CENTER_CARD_HEIGHT * 0.25) },
        { x: (cw * 4.35), y: (ch * 11) + (PORTRAIT_CENTER_CARD_HEIGHT * 0.65) },
        { x: (cw * 4.35) + (PORTRAIT_CENTER_CARD_WIDTH * 0.5), y: (ch * 11) + (PORTRAIT_CENTER_CARD_HEIGHT * 0.25) },
    ],
    6: [
        { x: cw * 4.35, y: ch * 11 },
        { x: (cw * 4.35) - (PORTRAIT_CENTER_CARD_WIDTH * 0.5), y: (ch * 11) + (PORTRAIT_CENTER_CARD_HEIGHT * 0.25) },
        { x: (cw * 4.35) - (PORTRAIT_CENTER_CARD_WIDTH * 0.5), y: (ch * 11) + (PORTRAIT_CENTER_CARD_HEIGHT * 0.6) },
        { x: (cw * 4.35), y: (ch * 11) + (PORTRAIT_CENTER_CARD_HEIGHT * 0.75) },
        { x: (cw * 4.35) + (PORTRAIT_CENTER_CARD_WIDTH * 0.5), y: (ch * 11) + (PORTRAIT_CENTER_CARD_HEIGHT * 0.6) },
        { x: (cw * 4.35) + (PORTRAIT_CENTER_CARD_WIDTH * 0.5), y: (ch * 11) + (PORTRAIT_CENTER_CARD_HEIGHT * 0.25) },
    ]
}

const portraitCenterCardsLayOut = {
    2: [
        { x: cw * 3.2, y: ch * 12 },
        { x: (cw * 3.2) + PORTRAIT_CENTER_CARD_WIDTH, y: ch * 12 }
    ],
    4: [
        { x: cw * 2.7, y: ch * 11 },
        { x: (cw * 2.7) + PORTRAIT_CENTER_CARD_WIDTH, y: ch * 11 },
        { x: (cw * 2.7) + (PORTRAIT_CENTER_CARD_WIDTH * 2), y: ch * 11 },
        { x: (cw * 2.7) + (PORTRAIT_CENTER_CARD_WIDTH * 3), y: ch * 11 }
    ],
    6: [
        { x: cw * 1.5, y: ch * 9 },
        { x: (cw * 1.5) + (PORTRAIT_CENTER_CARD_WIDTH * 1), y: ch * 9 },
        { x: (cw * 1.5) + (PORTRAIT_CENTER_CARD_WIDTH * 2), y: ch * 9 },
        { x: (cw * 1.5) + (PORTRAIT_CENTER_CARD_WIDTH * 3), y: ch * 9 },
        { x: (cw * 1.5) + (PORTRAIT_CENTER_CARD_WIDTH * 4), y: ch * 9 },
        { x: (cw * 1.5) + (PORTRAIT_CENTER_CARD_WIDTH * 5), y: ch * 9 },
    ]
}

const portraitDealerLayout = {
    2: [
        { x: cw * 4, y: ch * 3.5 },
        { x: cw * 6.5, y: ch * 16.65 },
    ],
    4: [
        { x: cw * 5.65, y: ch * 2.25 },
        { x: cw * 2.2, y: ch * 6.3 },
        { x: cw * 5.65, y: ch * 16.85 },
        { x: cw * 7.3, y: ch * 6.3 },
    ],
    6: [
        { x: cw * 5.65, y: ch * 2.25 },
        { x: cw * 3.25, y: ch * 3.3 },
        { x: cw * 2.2, y: ch * 6.3 },
        { x: cw * 5.65, y: ch * 16.85 },
        { x: cw * 7.3, y: ch * 6.3 },
        { x: cw * 6.75, y: ch * 3.3 },
    ]
}

const portraitTimerPositionLayout = {
    2: [
        // { x: cw * 4.05, y: ch * 3.35 },
        { x: cw * 4.05, y: ch * 2 },
        { x: cw * 4.05, y: ch * 18 },
    ],
    4: [
        { x: cw * 4.05, y: ch * 3.35 },
        { x: cw * 0.65, y: ch * 7.35 },
        { x: cw * 4.05, y: ch * 17.9 },
        { x: cw * 7.3, y: ch * 7.35 },
    ],
    6: [
        { x: cw * 4.05, y: ch * 3.35 },
        { x: cw * 1.65, y: ch * 4.35 },
        { x: cw * 0.65, y: ch * 7.35 },
        // { x: cw * 0.75, y: ch * 14.5 },
        { x: cw * 4.05, y: ch * 17.9 },
        // { x: cw * 7.3, y: ch * 14.5 },
        { x: cw * 7.3, y: ch * 7.35 },
        { x: cw * 6.65, y: ch * 4.35 },
    ]
}

const portraitDigitalTimerPositionLayout = {
    2: [
        // { x: cw * 4.05, y: ch * 3.35 },
        { x: cw * 3.5, y: ch * 1.9 },
        { x: cw * 6.15, y: ch * 17.9 },
    ],
    4: [
        { x: cw * 4.05, y: ch * 3.35 },
        { x: cw * 0.65, y: ch * 7.35 },
        { x: cw * 4.05, y: ch * 17.9 },
        { x: cw * 7.3, y: ch * 7.35 },
    ],
    6: [
        { x: cw * 4.05, y: ch * 3.35 },
        { x: cw * 1.65, y: ch * 4.35 },
        { x: cw * 0.65, y: ch * 7.35 },
        // { x: cw * 0.75, y: ch * 14.5 },
        { x: cw * 4.05, y: ch * 17.9 },
        // { x: cw * 7.3, y: ch * 14.5 },
        { x: cw * 7.3, y: ch * 7.35 },
        { x: cw * 6.65, y: ch * 4.35 },
    ]
}


const portraitTrucoLayout = {
    seatLayout: portraitSeatLayout,
    seatPointsLayout: portraitSeatPointsLayout,
    cardLayout: portraitCardsLayout,
    centerCardLayout: portraitCenterCardsLayOut,
    stackCenterCardsLayout: portraitStackCenterCardsLayOut,
    dealerIconLayout: portraitDealerLayout,
    timerPositionLayout: portraitTimerPositionLayout,
    digitalTimerPositionLayout: portraitDigitalTimerPositionLayout,
    cardWidth: PORTRAIT_CARD_WIDTH,
    cardHeight: PORTRAIT_CARD_HEIGHT,
    centerCardWidth: PORTRAIT_CENTER_CARD_WIDTH,
    centerCardHeight: PORTRAIT_CENTER_CARD_HEIGHT,
    centerMultiCardWidth: PORTRAIT_CENTER_MULTI_CARD_WIDTH,
    centerMultiHeight: PORTRAIT_CENTER_MULTI_CARD_HEIGHT,
    backCardWidth: PORTRAIT_BACK_CARD_WIDTH,
    backCardHeight: PORTRAIT_BACK_CARD_HEIGHT,
    heightGap: PORTRAIT_CARD_HEIGHT * 0.03,
    backCardHeightGap: PORTRAIT_BACK_CARD_HEIGHT * 0.057,
    widthGap: PORTRAIT_CARD_WIDTH * 0.6,
    backCardWidthGap: PORTRAIT_BACK_CARD_WIDTH * 0.6,
    centerCardWidthGap: PORTRAIT_CENTER_CARD_WIDTH * 0.6,
    centerCardHeightGap: PORTRAIT_CENTER_CARD_HEIGHT * 0.057,
    centerMultiCardWidthGap: PORTRAIT_CENTER_MULTI_CARD_WIDTH * 0.6,
    centerMultiCardHeightGap: PORTRAIT_CENTER_MULTI_CARD_HEIGHT * 0.057,
    rotation: PORTRAIT_CARD_WIDTH * (5 / 180),
    backCardRatioIndex: backCardRatioIndex,
    ratioIndex: ratioIndex,
}

export { portraitSeatLayout, portraitCenterCardsLayOut, portraitCardsLayout, portraitDealerLayout, portraitTrucoLayout, portraitTimerPositionLayout }







// | Width | Height |          |
// | ----- | ------ | -------- |
// | 144   | 224    | (k = 16) |
// | 153   | 238    | (k = 17) |
// | 162   | 252    | (k = 18) |
// | 171   | 266    | (k = 19) |
// | 180   | 280    | (k = 20) |
// | 189   | 294    | (k = 21) |
// | 198   | 308    | (k = 22) |
// | 207   | 322    | (k = 23) |
// | 216   | 336    | (k = 24) |
// | 225   | 350    | (k = 25) |
